import React from 'react';
import styles from './VideoModal.module.css';

interface VideoModalProps {
	show: boolean;
	onClose: () => void;
	videoId: string;
}

const VideoModal: React.FC<VideoModalProps> = ({ show, onClose, videoId }) => {
	if (!show) return null;

	const videoSrc = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1`;

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
				<iframe
					className={styles.videoFrame}
					src={videoSrc}
					title="Tutorial Video"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen
				></iframe>
			</div>
		</div>
	);
};

export default VideoModal;
